import { default as indexVxb2vPgQKhMeta } from "/opt/buildhome/repo/pages/[catSlug]-a[catId]/index.vue?macro=true";
import { default as auth_46clientoGUGf67ESyMeta } from "/opt/buildhome/repo/pages/auth.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/opt/buildhome/repo/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as error_45system_45testy4D4oTwV0mMeta } from "/opt/buildhome/repo/pages/error-system-test.vue?macro=true";
import { default as adreslerim_46cliente3fns6ZyCRMeta } from "/opt/buildhome/repo/pages/hesap/adreslerim.client.vue?macro=true";
import { default as ayarlarwutvNYRPU2Meta } from "/opt/buildhome/repo/pages/hesap/ayarlar.vue?macro=true";
import { default as indexQZT1b0vaO8Meta } from "/opt/buildhome/repo/pages/hesap/index.vue?macro=true";
import { default as logoutlNfVyNXdoIMeta } from "/opt/buildhome/repo/pages/hesap/logout.vue?macro=true";
import { default as _91id_93_46clienttgiwSL5QBJMeta } from "/opt/buildhome/repo/pages/hesap/siparislerim/[id].client.vue?macro=true";
import { default as index_46client1Owct80pOyMeta } from "/opt/buildhome/repo/pages/hesap/siparislerim/index.client.vue?macro=true";
import { default as _91id_93_46clientR9vIrg0D3sMeta } from "/opt/buildhome/repo/pages/hesap/sorularim/[id].client.vue?macro=true";
import { default as index_46clientr89w4H9zLEMeta } from "/opt/buildhome/repo/pages/hesap/sorularim/index.client.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as ayarlarPJCLxOPPh1Meta } from "/opt/buildhome/repo/pages/management/ayarlar.vue?macro=true";
import { default as duzenle8FSZ0v7QlJMeta } from "/opt/buildhome/repo/pages/management/email/blade-sablon/[type]/duzenle.vue?macro=true";
import { default as olusturxs0NoqOhzDMeta } from "/opt/buildhome/repo/pages/management/email/blade-sablon/olustur.vue?macro=true";
import { default as blade_45sablonlarT0Z2hsxod9Meta } from "/opt/buildhome/repo/pages/management/email/blade-sablonlar.vue?macro=true";
import { default as indexqLU38zTML3Meta } from "/opt/buildhome/repo/pages/management/email/index.vue?macro=true";
import { default as duzenleSRujTOR0j1Meta } from "/opt/buildhome/repo/pages/management/email/sablon/[id]/duzenle.vue?macro=true";
import { default as olustursIixO94DLaMeta } from "/opt/buildhome/repo/pages/management/email/sablon/olustur.vue?macro=true";
import { default as index4IwhdWTQg5Meta } from "/opt/buildhome/repo/pages/management/index.vue?macro=true";
import { default as duzenleybG9EX7zrAMeta } from "/opt/buildhome/repo/pages/management/kuponlar/[id]/duzenle.vue?macro=true";
import { default as indexwdDS2dlNbmMeta } from "/opt/buildhome/repo/pages/management/kuponlar/[id]/index.vue?macro=true";
import { default as indexrr62twVKjRMeta } from "/opt/buildhome/repo/pages/management/kuponlar/index.vue?macro=true";
import { default as istatistiklerHXrN3IV9ESMeta } from "/opt/buildhome/repo/pages/management/kuponlar/istatistikler.vue?macro=true";
import { default as yenijaeER3uqtfMeta } from "/opt/buildhome/repo/pages/management/kuponlar/yeni.vue?macro=true";
import { default as loginzMPT6mVAPsMeta } from "/opt/buildhome/repo/pages/management/login.vue?macro=true";
import { default as indexpoXhTN6ENlMeta } from "/opt/buildhome/repo/pages/management/musteriler/index.vue?macro=true";
import { default as _91id_93iFq71fZeZnMeta } from "/opt/buildhome/repo/pages/management/siparisler/[id].vue?macro=true";
import { default as indexfnC0ji6E41Meta } from "/opt/buildhome/repo/pages/management/siparisler/index.vue?macro=true";
import { default as sorularxo5ORzZZczMeta } from "/opt/buildhome/repo/pages/management/sorular.vue?macro=true";
import { default as _91id_93tdKoKNdyiRMeta } from "/opt/buildhome/repo/pages/management/urunler/[id].vue?macro=true";
import { default as indexQjsGaLoyuSMeta } from "/opt/buildhome/repo/pages/management/urunler/index.vue?macro=true";
import { default as yorumlarkU0qOOpbGiMeta } from "/opt/buildhome/repo/pages/management/yorumlar.vue?macro=true";
import { default as iade_45ve_45degisimqZtTGPbGTdMeta } from "/opt/buildhome/repo/pages/menu/iade-ve-degisim.vue?macro=true";
import { default as odeme_46clientdQKBjYdOfSMeta } from "/opt/buildhome/repo/pages/odeme.client.vue?macro=true";
import { default as sepet8PQftGDuFrMeta } from "/opt/buildhome/repo/pages/sepet.vue?macro=true";
import { default as sifremi_45unuttum_46clientRvhIYPHjGlMeta } from "/opt/buildhome/repo/pages/sifremi-unuttum.client.vue?macro=true";
import { default as tesekkurler_46clientD3Mu7sNm70Meta } from "/opt/buildhome/repo/pages/tesekkurler.client.vue?macro=true";
import { default as test_45native_45backMN4tnsoBjBMeta } from "/opt/buildhome/repo/pages/test-native-back.vue?macro=true";
import { default as _91slug_93_45_45_91urlParams_93YYNsBZcMXuMeta } from "/opt/buildhome/repo/pages/urun/[slug]--[urlParams].vue?macro=true";
export default [
  {
    name: "catSlug-acatId",
    path: "/:catSlug()-a:catId()",
    component: () => import("/opt/buildhome/repo/pages/[catSlug]-a[catId]/index.vue").then(m => m.default || m)
  },
  {
    name: "auth",
    path: "/auth",
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/auth.client.vue").then(m => m.default || m))
  },
  {
    name: "error-system-test",
    path: "/error-system-test",
    component: () => import("/opt/buildhome/repo/pages/error-system-test.vue").then(m => m.default || m)
  },
  {
    name: "hesap-adreslerim",
    path: "/hesap/adreslerim",
    meta: adreslerim_46cliente3fns6ZyCRMeta || {},
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/hesap/adreslerim.client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-ayarlar",
    path: "/hesap/ayarlar",
    meta: ayarlarwutvNYRPU2Meta || {},
    component: () => import("/opt/buildhome/repo/pages/hesap/ayarlar.vue").then(m => m.default || m)
  },
  {
    name: "hesap",
    path: "/hesap",
    meta: indexQZT1b0vaO8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/hesap/index.vue").then(m => m.default || m)
  },
  {
    name: "hesap-logout",
    path: "/hesap/logout",
    component: () => import("/opt/buildhome/repo/pages/hesap/logout.vue").then(m => m.default || m)
  },
  {
    name: "hesap-siparislerim-id",
    path: "/hesap/siparislerim/:id()",
    meta: _91id_93_46clienttgiwSL5QBJMeta || {},
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/hesap/siparislerim/[id].client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-siparislerim",
    path: "/hesap/siparislerim",
    meta: index_46client1Owct80pOyMeta || {},
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/hesap/siparislerim/index.client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-sorularim-id",
    path: "/hesap/sorularim/:id()",
    meta: _91id_93_46clientR9vIrg0D3sMeta || {},
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/hesap/sorularim/[id].client.vue").then(m => m.default || m))
  },
  {
    name: "hesap-sorularim",
    path: "/hesap/sorularim",
    meta: index_46clientr89w4H9zLEMeta || {},
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/hesap/sorularim/index.client.vue").then(m => m.default || m))
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "management-ayarlar",
    path: "/management/ayarlar",
    meta: ayarlarPJCLxOPPh1Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/ayarlar.vue").then(m => m.default || m)
  },
  {
    name: "management-email-blade-sablon-type-duzenle",
    path: "/management/email/blade-sablon/:type()/duzenle",
    meta: duzenle8FSZ0v7QlJMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/blade-sablon/[type]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-email-blade-sablon-olustur",
    path: "/management/email/blade-sablon/olustur",
    meta: olusturxs0NoqOhzDMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/blade-sablon/olustur.vue").then(m => m.default || m)
  },
  {
    name: "management-email-blade-sablonlar",
    path: "/management/email/blade-sablonlar",
    meta: blade_45sablonlarT0Z2hsxod9Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/blade-sablonlar.vue").then(m => m.default || m)
  },
  {
    name: "management-email",
    path: "/management/email",
    meta: indexqLU38zTML3Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/index.vue").then(m => m.default || m)
  },
  {
    name: "management-email-sablon-id-duzenle",
    path: "/management/email/sablon/:id()/duzenle",
    meta: duzenleSRujTOR0j1Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/sablon/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-email-sablon-olustur",
    path: "/management/email/sablon/olustur",
    meta: olustursIixO94DLaMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/email/sablon/olustur.vue").then(m => m.default || m)
  },
  {
    name: "management",
    path: "/management",
    meta: index4IwhdWTQg5Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/index.vue").then(m => m.default || m)
  },
  {
    name: "management-kuponlar-id-duzenle",
    path: "/management/kuponlar/:id()/duzenle",
    meta: duzenleybG9EX7zrAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/kuponlar/[id]/duzenle.vue").then(m => m.default || m)
  },
  {
    name: "management-kuponlar-id",
    path: "/management/kuponlar/:id()",
    meta: indexwdDS2dlNbmMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/kuponlar/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "management-kuponlar",
    path: "/management/kuponlar",
    meta: indexrr62twVKjRMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/kuponlar/index.vue").then(m => m.default || m)
  },
  {
    name: "management-kuponlar-istatistikler",
    path: "/management/kuponlar/istatistikler",
    meta: istatistiklerHXrN3IV9ESMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/kuponlar/istatistikler.vue").then(m => m.default || m)
  },
  {
    name: "management-kuponlar-yeni",
    path: "/management/kuponlar/yeni",
    meta: yenijaeER3uqtfMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/kuponlar/yeni.vue").then(m => m.default || m)
  },
  {
    name: "management-login",
    path: "/management/login",
    meta: loginzMPT6mVAPsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/login.vue").then(m => m.default || m)
  },
  {
    name: "management-musteriler",
    path: "/management/musteriler",
    meta: indexpoXhTN6ENlMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/musteriler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-siparisler-id",
    path: "/management/siparisler/:id()",
    meta: _91id_93iFq71fZeZnMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/siparisler/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-siparisler",
    path: "/management/siparisler",
    meta: indexfnC0ji6E41Meta || {},
    component: () => import("/opt/buildhome/repo/pages/management/siparisler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-sorular",
    path: "/management/sorular",
    meta: sorularxo5ORzZZczMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/sorular.vue").then(m => m.default || m)
  },
  {
    name: "management-urunler-id",
    path: "/management/urunler/:id()",
    meta: _91id_93tdKoKNdyiRMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/urunler/[id].vue").then(m => m.default || m)
  },
  {
    name: "management-urunler",
    path: "/management/urunler",
    meta: indexQjsGaLoyuSMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/urunler/index.vue").then(m => m.default || m)
  },
  {
    name: "management-yorumlar",
    path: "/management/yorumlar",
    meta: yorumlarkU0qOOpbGiMeta || {},
    component: () => import("/opt/buildhome/repo/pages/management/yorumlar.vue").then(m => m.default || m)
  },
  {
    name: "menu-iade-ve-degisim",
    path: "/menu/iade-ve-degisim",
    component: () => import("/opt/buildhome/repo/pages/menu/iade-ve-degisim.vue").then(m => m.default || m)
  },
  {
    name: "odeme",
    path: "/odeme",
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/odeme.client.vue").then(m => m.default || m))
  },
  {
    name: "sepet",
    path: "/sepet",
    component: () => import("/opt/buildhome/repo/pages/sepet.vue").then(m => m.default || m)
  },
  {
    name: "sifremi-unuttum",
    path: "/sifremi-unuttum",
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/sifremi-unuttum.client.vue").then(m => m.default || m))
  },
  {
    name: "tesekkurler",
    path: "/tesekkurler",
    component: () => createClientPage(() => import("/opt/buildhome/repo/pages/tesekkurler.client.vue").then(m => m.default || m))
  },
  {
    name: "test-native-back",
    path: "/test-native-back",
    component: () => import("/opt/buildhome/repo/pages/test-native-back.vue").then(m => m.default || m)
  },
  {
    name: "urun-slug--urlParams",
    path: "/urun/:slug()--:urlParams()",
    component: () => import("/opt/buildhome/repo/pages/urun/[slug]--[urlParams].vue").then(m => m.default || m)
  }
]